import request from '@/utils/request'


//epmsa012Detail
export function epmsa014Detail(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa014/epmsa014Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
